import { useState } from "react";
import { Typography, Button, Collapse, ListItem, Input } from "@mui/material";
import { tss } from "tss-react";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { getPlaneInputValues } from "actions/GlobalActions";
import commonStyles, { backgroundColor } from "styles/common";

const useStyles = tss.create({
    sectionContainer: {
        borderTop: "solid 1px #f0f0f0",
        lineHeight: 0,
        backgroundColor: backgroundColor,
    },
    sectionLabel: {
        margin: 0,
        marginLeft: -5,
        display: "flex",
        alignItems: "center",
        fontSize: 14,
        color: "#434343",
        width: 280,
    },
    arrow: {
        width: 16,
        height: 16,
        position: "relative",
        left: 4,
    },
    listItem: {
        height: 40,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "&:hover": {
            backgroundColor: "transparent",
        },
    },
    content: {
        marginTop: 20,
        padding: "2px 0px 8px 15px",
    },
    label: {
        color: "#434343",
        fontSize: 14,
        letterSpacing: 0,
        lineHeight: "16px",
    },
    row: {
        height: 35,
        display: "flex",
        alignItems: "center",
        width: "100%",
        position: "relative",
    },
    select: {
        width: 270,
        height: 40,
        display: "inline-flex",
        alignItems: "center",
        textOverflow: "ellipsis",
        textAlign: "left",
        whiteSpace: "nowrap",
        overflow: "hidden",
    },
    numberInput: {
        color: "black",
        textAlign: "left",
        fontSize: 14,
        marginTop: 0,
        width: 100,
    },
    middle: {
        display: "flex",
        alignItems: "center",
    },
    name: {
        marginTop: -5,
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden",
        maxWidth: 270,
    },
    applyButton: {
        marginBottom: 0,
        marginTop: 5,
        textAlign: "right",
    },
    menuItem: {
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden",
        width: 270,
    },
    right: {
        position: "absolute",
        right: 0,
    },
});

type globalState = {
    showPlane: boolean;
    planeValue: number;
};

let globalSettings: globalState[] = [];

const collapseState = {
    ImageryPlane: false,
};

type IRasterImagery = {
    currentProject: any;
    layer: any;
    handleLayerEvent: (eventId: any, data: any, layer: any) => void;
};

export default function ImageryPlane(props: IRasterImagery) {
    const { classes } = useStyles();
    const { classes: common } = commonStyles();
    const { layer, handleLayerEvent } = props;

    const initialState = {
        showPlane: false,
        planeValue: layer["input_value_plane_d"] ? Math.abs(parseInt(layer["input_value_plane_d"])) : 0,
    };
    if (!globalSettings[layer.ID]) {
        globalSettings[layer.ID] = initialState;
    }
    const [open, setOpen] = useState(collapseState.ImageryPlane);
    const [planeValue, setPlaneValue] = useState(globalSettings[layer.ID].planeValue);
    const [needsApply, setNeedsApply] = useState(false);

    const handleClick = () => {
        setOpen(!open);
        collapseState.ImageryPlane = !open;
    };

    const handleChange = (evt: any) => {
        var value = parseInt(evt.target.value);
        globalSettings[layer.ID].planeValue = value;
        setPlaneValue(value);
        setNeedsApply(true);
    };

    function applySettings() {
        var { a, b, c, d } = getPlaneInputValues(planeValue);
        layer["input_value_plane_a"] = a;
        layer["input_value_plane_b"] = b;
        layer["input_value_plane_c"] = c;
        layer["input_value_plane_d"] = d;
        handleLayerEvent("refreshView", null, layer);
        setNeedsApply(false);
    }

    return (
        <div className={classes.sectionContainer}>
            <ListItem onClick={handleClick} className={classes.listItem}>
                <Typography className={classes.sectionLabel}>Imagery Plane</Typography>
                {open ? <ExpandLess className={classes.arrow} /> : <ExpandMore className={classes.arrow} />}
            </ListItem>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <div className={common.sectionContent} style={{ marginTop: -12 }}>
                    <div className={classes.row}>
                        <Typography className={common.label}>Set Plane Value</Typography>
                        <div className={classes.right}>
                            <Input
                                type="number"
                                inputProps={{ min: 0 }}
                                value={planeValue}
                                className={classes.numberInput}
                                onChange={handleChange}
                            />
                        </div>
                    </div>
                    {needsApply ? (
                        <div className={classes.applyButton}>
                            <Button
                                color="primary"
                                onClick={applySettings}
                                title="This panel contains changes that were not applied to the viewer. Click this button to update the view."
                            >
                                Apply
                            </Button>
                        </div>
                    ) : (
                        ""
                    )}
                </div>
            </Collapse>
        </div>
    );
}
